import { useConsentStore } from '@/store/playerStore';
import { audioEngine } from '@/features/audio/audioEngine';
import { Radio, Play } from 'lucide-react';
import { PRODUCT } from '@/config/product.config';

export function ConsentGate() {
  const consent = useConsentStore((s) => s.consent);
  const grant = useConsentStore((s) => s.grant);
  const deny = useConsentStore((s) => s.deny);

  if (consent !== 'not_given') return null;

  const handleGrant = () => {
    grant();
    audioEngine.onConsentGranted();
  };

  return (
    <div
      className="absolute inset-0 z-50 flex items-center justify-center bg-navy-950/80 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="consent-title"
    >
      <div className="mx-4 max-w-sm rounded-2xl glass-strong p-6 text-center shadow-glow-strong">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-500/15 text-accent-300">
          <Radio className="h-7 w-7 animate-signal-pulse" />
        </div>
        <h2 id="consent-title" className="mb-2 text-base font-bold text-slate-50">
          Dinlemeyi Başlat
        </h2>
        <p className="mb-5 text-sm text-slate-400">
          {PRODUCT.name}, radyo akışlarını çalmak için ses oynatma iznine ihtiyaç duyar.
          Tarayıcı, sesi yalnızca siz onayladıktan sonra başlatır.
        </p>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={handleGrant}
            className="flex items-center justify-center gap-2 rounded-lg bg-accent-500 px-4 py-2.5 text-sm font-semibold text-navy-950 transition-colors hover:bg-accent-400"
          >
            <Play className="h-4 w-4" />
            Dinlemeyi Başlat
          </button>
          <button
            type="button"
            onClick={deny}
            className="rounded-lg px-4 py-2 text-xs text-slate-400 transition-colors hover:text-slate-200"
          >
            Şimdilik değil
          </button>
        </div>
      </div>
    </div>
  );
}
